export default __webpack_public_path__ + "static/media/namesjeff.7d05e674.jpg";